import React, { FC } from 'react'
import {
  Panel,
  Stack,
  Placeholder,
} from 'rsuite'
import useTranslation from 'next-translate/useTranslation'

import { ReviewRatingQuantity } from '../../../utils/types/Review'
import ReviewStars from './ReviewStars'
import ReviewHistogram from './ReviewHistogram'
import { getAverageOfReviews, getTotalOfReviews } from '../../../utils/reviewUtils'

import styles from '../../../styles/SingleProductReviewsSection.module.less'

interface ReviewHistogramPanelProps {
  ratingQuantities: ReviewRatingQuantity[]
  isLoadingInitial: boolean
}

const ReviewHistogramPanel: FC<ReviewHistogramPanelProps> = (props) => {
  const { ratingQuantities, isLoadingInitial } = props
  const { t } = useTranslation('products')

  const total = getTotalOfReviews(ratingQuantities)
  const average = getAverageOfReviews(ratingQuantities)

  return (
    <Panel className={`${styles['histogram-panel']} text-center`}>
      {isLoadingInitial ? (
        <Stack
          spacing={20}
          direction="column"
          className="full-w"
          alignItems="stretch"
        >
          <Stack
            spacing={10}
            direction="column"
            className="full-w"
            alignItems="center"
          >
            <Placeholder.Graph
              // Need to make it a circle manually because graph="circle" loses the animation
              className={styles['placeholder-histogram-circle']}
              width={70}
              height={70}
              active
            />
            <Placeholder.Paragraph
              rows={1}
              rowHeight={15}
              className={styles['placeholder-reviews-section-80']}
              active
            />
            <Placeholder.Paragraph
              rows={1}
              rowHeight={15}
              className={styles['placeholder-reviews-section-130']}
              active
            />
          </Stack>
          <Placeholder.Paragraph
            rows={5}
            rowHeight={15}
            className={styles['placeholder-histogram-bar']}
            active
          />
        </Stack>
      ) : (
        <Stack
          spacing={15}
          direction="column"
          className="full-w"
          alignItems="stretch"
        >
          <Stack
            spacing={0}
            direction="column"
            className="full-w"
          >
            <p className={styles['histogram-header']}>{average.toFixed(1)}</p>
            <ReviewStars average={average} />
            <p>{t('Based on {{ count }} reviews', { count: total })}</p>
          </Stack>
          <ReviewHistogram ratingQuantities={ratingQuantities} />
        </Stack>
      )}
    </Panel>
  )
}

export default ReviewHistogramPanel
